'use client';

import { defineMessage, useIntl } from 'react-intl';

import { SlotLink } from './Slot.Link';

const title = defineMessage({
  id: 'slot.joe.label',
  defaultMessage: 'Bonus Club',
});

export const JoeSlot = () => {
  const { formatMessage } = useIntl();

  return (
    <SlotLink href="/service-hilfe/joe-bonus-club" label={formatMessage(title)}>
      <div className="icon-emp-joe-logo h-4 w-4" />
    </SlotLink>
  );
};
